<template>
    <v-container>
        <v-row>
            <v-col cols="6">
                <v-select v-model="filterEvent" :items="events" label="Choose an Event" outlined>
                    <v-icon
                        v-if="filterEvent"
                        slot="append-outer"
                        class="pr-4"
                        style="cursor: pointer"
                        @click="filterEvent = null"
                    >
                        mdi-close
                    </v-icon>
                </v-select>
            </v-col>
            <v-col cols="6">
                <v-select v-model="filterRound" :items="rounds" outlined>
                    <v-icon
                        v-if="filterRound"
                        slot="append-outer"
                        class="pr-4"
                        style="cursor: pointer"
                        @click="filterRound = null"
                    >
                        mdi-close
                    </v-icon>
                </v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-sparkline
                    v-if="filterEvent"
                    :labels="labels"
                    :value="aggregate"
                    :gradient="gradient"
                    :smooth="radius || false"
                    :padding="padding"
                    :line-width="width"
                    :stroke-linecap="lineCap"
                    :gradient-direction="gradientDirection"
                    :fill="fill"
                    :type="type"
                    :auto-line-width="autoLineWidth"
                    auto-draw
                    show-labels
                />
            </v-col>
        </v-row>

        <v-card v-if="false" elevation="0">
            <v-card-text>
                <v-alert dense border="left" text type="info"> Coming soon!</v-alert>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import Athlete from '@/Models/Athlete.js';
import Result from '@/Models/Result.js';

const gradients = [
    ['#222'],
    ['#42b3f4'],
    ['red', 'orange', 'yellow'],
    ['purple', 'violet'],
    ['#00c6ff', '#F0F', '#FF0'],
    ['#f72047', '#ffd200', '#1feaea'],
];

export default {
    name: 'AthleteTrends',

    props: {
        athleteId: {
            type: Number,
            required: true,
        },
    },

    data: () => ({
        width: 2,
        radius: 10,
        padding: 8,
        lineCap: 'round',
        gradient: gradients[5],
        value: [0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0],
        gradientDirection: 'top',
        gradients,
        fill: false,
        type: 'trend',
        autoLineWidth: false,

        filterEvent: null,
        filterRound: 'total_score',
        events: [
            {
                text: 'TRA',
                value: 'TI',
            },
            {
                text: 'DMT',
                value: 'DM',
            },
            {
                text: 'TUM',
                value: 'TU',
            },
            {
                text: 'SYN',
                value: 'TS',
            },
        ],
        rounds: [
            {
                text: 'Prelims',
                value: 'prelims_score',
            },
            {
                text: 'Finals',
                value: 'finals_score',
            },
            {
                text: 'Total Score',
                value: 'total_score',
            },
        ],
    }),

    computed: {
        athlete() {
            return Athlete.query()
                .with(['results.meet', 'results.category', 'club', 'results.club'])
                .with('results', query => {
                    if (this.filterEvent) {
                        query.where('event', this.filterEvent);
                    }
                })
                .find(this.athleteId);
        },

        results() {
            return Result.query()
                .with('meet')
                .where('athlete_id', this.athleteId)
                .where('event', this.filterEvent)
                .get();
        },

        labels() {
            return _.map(this.results, 'meet.title');
        },

        aggregate() {
            return _.filter(_.map(this.results, this.filterRound));
        },
    },
};
</script>
